





















































































































import { Component, Vue, Emit, Prop, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { DateTime } from 'luxon'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import { maskMoney, maskCPFCNPJ } from '@/utils/common'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import { Loading } from '@/types/_'

@Component

export default class ComponentModalNFExtrato extends Vue {
  @Prop({ required: true, default: false }) disabled: boolean

  $refs!: {
    formRules: any,
    dateA: any,
    documentos: any,
  }

  formRules: any = {
    valid: true,
    dataRecebimentoNota: [v => !!v || 'O campo data de recebimento da nota é obrigatório.'],
    numeroNota: [v => !!v || 'O campo número da nota é obrigatório.'],
    numeroContasPagar: [v => !!v || 'O campo número contas a pagar é obrigatório.'],
    valorNotaFiscal: [v => !!v || 'O campo valor da nota é obrigatório.'],
  }

  loadAnexo: boolean = false
  loadDeletar: boolean = false
  loadConfirmar: boolean = false
  motivo: any[] = []
  dateText1: string = ''
  imageUrl: string = ''
  anexo: any = {}
  arquivoNome: any = ''
  enableConfirmar: boolean = false
  loading: Loading = {
    status: false,
    text: '',
  }

  get loadingDeletar() {
    return this.loadDeletar
  }

  set loadingDeletar(value: boolean) {
    this.loadDeletar = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  set loadingAnexo(value: boolean) {
    this.loadAnexo = value
  }

  get loadingAnexo() {
    return this.loadAnexo
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get recebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get showModal() {
    return this.recebimentoStore.modalDadosNF
  }

  get anexoNotaFiscal() {
    return this.anexo
  }

  set anexoNotaFiscal(value: any) {
    this.anexo = value
  }

  get nomeArquivoOriginal() {
    return this.arquivoNome
  }

  set nomeArquivoOriginal(value: string) {
    this.arquivoNome = value
  }

  get numeroNota() {
    return this.recebimentoStore.numeroNota
  }

  set numeroNota(value: string) {
    this.recebimentoStore.setNumeroNota(value)
  }

  get valorNotaFiscal() {
    return this.recebimentoStore.valorNotaFiscal
  }

  set valorNotaFiscal(value: string) {
    this.recebimentoStore.setValorNotaFiscal(value)
  }

  get isEnableConfirmar() {
    return this.enableConfirmar
  }

  set isEnableConfirmar(value: boolean) {
    this.enableConfirmar = value
  }

  get getRequestMessage() {
    return this.recebimentoStore.requestMessage
  }

  async confirmar() {
    this.loadingConfirmar = true
    const { files } = this.$refs.documentos.$refs.upload

    if (this.$refs.formRules.validate()) {
      if (files.length < 1 && this.nomeArquivoOriginal === '') {
        EventBus.$emit('setSnackbar', { show: true, text: 'É necessário anexar uma nota fiscal.', icon: 'warning', color: '#C62828' })
        this.loadingConfirmar = false
        return false
      }

      if (files.length > 0) {
        const params: any = {
          prestadorRecebimentoId: this.recebimentoStore.nfSelected.id,
          formData: this.anexoNotaFiscal.formData,
        }
        const step1 = await this.getFinanceiroStore.uploadNotaFiscalUnica(params)
        if (!step1.success) {
          EventBus.$emit('setSnackbar', { show: true, text: step1.message || 'Houve um problema ao enviar nota fiscal', icon: 'warning', color: '#C62828' })
          this.loadingConfirmar = false
          return false
        }
        files.splice(0, files.length)
      }

      const params: any = {
        prestadorRecebimentoId: this.recebimentoStore.nfSelected.id,
        numeroNota: this.numeroNota,
        valorNotaFiscal: this.valorNotaFiscal,
        dataRecebimentoNota: DateTime.local().toISO(),
        numeroContasPagar: "0",
        motivo: ["Nenhum"],
      }

      if (this.recebimentoStore.nfSelected.acoes.permiteMultiplasNFs) {
        params.documentoId = this.getFinanceiroStore.idForConfirmar
      }

      const response = await this.getFinanceiroStore.atualizarRecebimetno(params)

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal atualizada com sucesso.', icon: 'done', color: '#2E7D32' })
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema na atualização da nota fiscal.', icon: 'warning', color: '#C62828' })
      }
    }

    this.loadingConfirmar = false
    return false
  }

  async deletar() {
    this.loadingDeletar = true
    const params: any = {
      prestadorRecebimentoId: this.recebimentoStore.nfSelected.id,
    }
    const response = await this.getFinanceiroStore.deletarDocumento(params)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal deletada com sucesso.', icon: 'done', color: '#2E7D32' })
      this.getFinanceiroStore.setNotaFIscalItemAnexo('')
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema ao deletar nota fiscal.', icon: 'warning', color: '#C62828' })
    }

    this.loadingDeletar = false
  }

  async inputFile(newFile, oldFile) {
    this.loadingAnexo = true

    if (!newFile || newFile.identifier) {
      return
    }

    const formData = new FormData()
    formData.append('notaFiscal', newFile.file)

    const params: any = {
      formData,
      prestadorRecebimentoId: this.recebimentoStore.nfSelected.id,
    }

    this.getFinanceiroStore.setNotaFIscalItemAnexo(newFile.name)
    this.nomeArquivoOriginal = newFile.name
    this.anexoNotaFiscal = params
    this.isEnableConfirmar = true
    
    EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal enviada com sucesso.', icon: 'done', color: '#2E7D32' })

    this.loadingAnexo = false
  }

  async download(prestadorRecebimentoId: string) {
    const response = await this.getFinanceiroStore.download({ prestadorRecebimentoId })
    const win = window.open()
    // @ts-ignore
    win.document.body.style.margin = '0'
    // @ts-ignore
    win.document.body.style.padding = '0'
    // @ts-ignore
    win.document.write(`<iframe src="${response.data}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%; margin:-8px;" allowfullscreen></iframe>`)
  }

  async closeModal() {
    this.recebimentoStore.setModalDadosNF(false)
    this.$refs.formRules.reset()
    this.recebimentoStore.clearModalDadosNF()
    this.nomeArquivoOriginal = ''
    this.isEnableConfirmar = false
    this.setLoadingRequest(true, this.getRequestMessage.init.text)
    await this.recebimentoStore.loadRecebimentos()
    this.clearLoadingRequest()
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loading.status = status
    this.loading.text = text
  }

  formatMoneyUtil(money: string) {
    return maskMoney(money)
  }

  maskCPFCNPJUtil(value: string) {
    return maskCPFCNPJ(value)
  }
}
